import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerificationSuccessDialogComponent } from './verification-success-dialog.component';
import { MaterialModule } from '@fantaz/shared/ui/material';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [VerificationSuccessDialogComponent],
  exports: [VerificationSuccessDialogComponent],
})
export class UserVerificationUiVerificationSuccessDialogModule {}
